export default __webpack_public_path__ + "static/media/mentorian.8360287e.jpg";